module.exports = __webpack_public_path__ + "assetsclientes/img/no-user.1ce7f279.png";